<template>
  <div class="con" v-loading="loading">
    <div class="text item">
      <div class="Table-Con" v-if="deviceSoftwareVer < 'v2.9'">
        <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
          <el-form-item :label="`${$t('lang.ConfigSetting.StartM2MPlatformControl')}：`" prop="name">
            <el-checkbox v-model="data.m2m_enabled" :disabled="data.m2m_enabled"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.HeartbeatInterval')}：`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.hbpt"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Heartbeattimeouttimes')}：`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.vtime"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.reportingFrequency')}：`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.loc_inter"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.NetStatusInterval')}：`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.nspt"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.ServerIP')}：`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.server_v2"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Port')}：`" prop="name">
            <el-input size="mini" class="Form-Input-Width" v-model="data.port_v2"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="deviceSoftwareVer >= 'v2.9'">
        <el-tabs type="border-card" v-model="select">
          <el-tab-pane label="常规" name="con">
            <el-divider content-position="left">平台配置</el-divider>
            <el-form ref="ruleForm2" :model="data" label-width="200px" class="demo-ruleForm">
              <el-form-item :label="'版本控制' + '：'" prop="hbpt">
                <el-select size="mini" v-model="data.version">
                  <el-option label="v2" value="v2"></el-option>
                  <el-option label="v3" value="v3"></el-option>
                  <el-option label="v2/v3" value="v2/v3"></el-option>
                </el-select>
              </el-form-item>
              <template v-if="data.version == 'v2'">
                <el-form-item :label="data.version + $t('lang.ConfigSetting.enable2') + '：'" prop="v2_enabled">
                  <el-checkbox v-model="data.v2_enabled" :disabled="data.v2_enabled"></el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.sercerOk') + '：'" prop="v2_ping_check">
                  <el-checkbox v-model="data.v2_ping_check"></el-checkbox>
                </el-form-item>
                <el-form-item :label="data.version + $t('lang.ConfigSetting.server') + '：'" prop="v2_server">
                  <div class="input_box">
                    <div class="input_list" v-for="(i, index) in data.v2_server">
                      <el-input v-model="data.v2_server[index]" size="mini" class="input_item"
                        :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
                      <el-button v-if="data.v2_server.length - 1 === index" size="mini" type="primary"
                        @click="addServer('v2')" icon="el-icon-plus" circle></el-button>
                      <el-button v-if="data.v2_server.length > 1 &&
                        index != data.v2_server.length - 1
                      " size="mini" type="danger" @click="delServer(index, 'v2')" icon="el-icon-minus"
                        circle></el-button>
                    </div>
                  </div>
                </el-form-item>
                <template v-if="deviceSoftwareVer >= 'v2.9.250301'">
                  <el-form-item :label="$t('lang.ConfigSetting.v2tcpServer') + '：'" prop="v2_tcp">
                    <div class="input_box">
                      <div class="input_list" v-for="(i, index) in data.v2_tcp">
                        <el-input v-model="data.v2_tcp[index]" size="mini" class="input_item"
                          :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
                        <el-button v-if="data.v2_tcp.length - 1 === index" size="mini" type="primary"
                          @click="addServer('v2')" icon="el-icon-plus" circle></el-button>
                        <el-button v-if="data.v2_tcp.length > 1 &&
                          index != data.v2_tcp.length - 1
                        " size="mini" type="danger" @click="delServer(index, 'v2')" icon="el-icon-minus"
                          circle></el-button>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('lang.ConfigSetting.v2mqttServer') + '：'" prop="v2_mqtt">
                    <div class="input_box">
                      <div class="input_list" v-for="(i, index) in data.v2_mqtt">
                        <el-input v-model="data.v2_mqtt[index]" size="mini" class="input_item"
                          :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
                        <el-button v-if="data.v2_mqtt.length - 1 === index" size="mini" type="primary"
                          @click="addServer('v2')" icon="el-icon-plus" circle></el-button>
                        <el-button v-if="data.v2_mqtt.length > 1 &&
                          index != data.v2_mqtt.length - 1
                        " size="mini" type="danger" @click="delServer(index, 'v2')" icon="el-icon-minus"
                          circle></el-button>
                      </div>
                    </div>
                  </el-form-item>
                </template>


                <el-form-item :label="data.version + $t('lang.ConfigSetting.status') + '：'" prop="v2_status">
                  <span>{{ connectInfo[data.v2_status] || '未连接' }}</span>
                </el-form-item>
              </template>
              <template v-else-if="data.version == 'v3'">
                <el-form-item :label="data.version + $t('lang.ConfigSetting.enable2') + '：'" prop="v3_enabled">
                  <el-checkbox v-model="data.v3_enabled" :disabled="data.v3_enabled"></el-checkbox>
                </el-form-item>
                <el-form-item :label="data.version + $t('lang.ConfigSetting.server') + '：'" prop="v3_server">
                  <div class="input_box">
                    <div class="input_list" v-for="(i, index) in data.v3_server">
                      <el-input v-model="data.v3_server[index]" size="mini" class="input_item"
                        :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
                      <el-button v-if="data.v3_server.length - 1 === index" size="mini" type="primary"
                        @click="addServer('v3')" icon="el-icon-plus" circle></el-button>
                      <el-button v-if="data.v3_server.length > 1 &&
                        index != data.v3_server.length - 1
                      " size="mini" type="danger" @click="delServer(index, 'v3')" icon="el-icon-minus"
                        circle></el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.upgrade') + '：'" prop="v3_upgrade_ready">
                  {{ data.v3_upgrade_ready ? '是' : '否' }}
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.mqttQos') + '：'" prop="v3_mqtt_qos">
                  <el-select size="mini" v-model="data.v3_mqtt_qos">
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.mqttAlive') + '：'" prop="v3_mqtt_alive">
                  <el-input size="mini" v-model="data.v3_mqtt_alive"></el-input>
                </el-form-item>
                <el-form-item :label="data.version + $t('lang.ConfigSetting.status') + '：'" prop="v3_status">
                  <span>{{ connectInfo[data.v3_status] || '未连接' }}</span>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item :label="'v2' + $t('lang.ConfigSetting.enable2') + '：'" prop="v2_enabled">
                  <el-checkbox v-model="data.v2_enabled" :disabled="data.v2_enabled"></el-checkbox>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.sercerOk') + '：'" prop="v2_ping_check">
                  <el-checkbox v-model="data.v2_ping_check"></el-checkbox>
                </el-form-item>
                <el-form-item :label="'v2' + $t('lang.ConfigSetting.server') + '：'" prop="v2_server">
                  <div class="input_box">
                    <div class="input_list" v-for="(i, index) in data.v2_server">
                      <el-input v-model="data.v2_server[index]" size="mini" class="input_item"
                        :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
                      <el-button v-if="data.v2_server.length - 1 === index" size="mini" type="primary"
                        @click="addServer('v2')" icon="el-icon-plus" circle></el-button>
                      <el-button v-if="data.v2_server.length > 1 &&
                        index != data.v2_server.length - 1
                      " size="mini" type="danger" @click="delServer(index, 'v2')" icon="el-icon-minus"
                        circle></el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item :label="'v2' + $t('lang.ConfigSetting.status') + '：'" prop="v2_status">
                  <span>{{ connectInfo[data.v2_status] || '未连接' }}</span>
                </el-form-item>
                <el-form-item :label="'v3' + $t('lang.ConfigSetting.enable2') + '：'" prop="v3_enabled">
                  <el-checkbox v-model="data.v3_enabled" :disabled="data.v3_enabled"></el-checkbox>
                </el-form-item>
                <el-form-item :label="'v3' + $t('lang.ConfigSetting.server') + '：'" prop="v3_server">
                  <div class="input_box">
                    <div class="input_list" v-for="(i, index) in data.v3_server">
                      <el-input v-model="data.v3_server[index]" size="mini" class="input_item"
                        :placeholder="$t('lang.networkMonitoring.pleaseEnter')"></el-input>
                      <el-button v-if="data.v3_server.length - 1 === index" size="mini" type="primary"
                        @click="addServer('v3')" icon="el-icon-plus" circle></el-button>
                      <el-button v-if="data.v3_server.length > 1 &&
                        index != data.v3_server.length - 1
                      " size="mini" type="danger" @click="delServer(index, 'v3')" icon="el-icon-minus"
                        circle></el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.upgrade') + '：'" prop="v3_upgrade_ready">
                  {{ data.v3_upgrade_ready ? '是' : '否' }}
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.mqttQos') + '：'" prop="v3_mqtt_qos">
                  <el-select size="mini" v-model="data.v3_mqtt_qos">
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('lang.ConfigSetting.mqttAlive') + '：'" prop="v3_mqtt_alive">
                  <el-input size="mini" v-model="data.v3_mqtt_alive"></el-input>
                </el-form-item>
                <el-form-item :label="'v3' + $t('lang.ConfigSetting.status') + '：'" prop="v3_status">
                  <span>{{ connectInfo[data.v3_status] || '未连接' }}</span>
                </el-form-item>
              </template>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="高级" name="adv">
            <el-form ref="advancedForm" :model="advanced" label-width="200px">
              <el-form-item :label="$t('lang.ConfigSetting.Enable')">
                <el-checkbox v-model="advanced.enabled"></el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('lang.ConfigSetting.debug')">
                <el-checkbox v-model="advanced.enable_debug"></el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('lang.smartlink.saveLogNumber')">
                <el-input class="input" size="mini" v-model="advanced.log_file_num"></el-input>
              </el-form-item>
              <el-form-item :label="$t('lang.smartlink.logSize')">
                <el-input class="input" size="mini" v-model="advanced.log_file_size"></el-input>
                <p class="tips">KB</p>
              </el-form-item>
              <el-form-item :label="$t('lang.smartlink.logPriority')">
                <el-select v-model="advanced.log_priority" size="mini">
                  <el-option v-for="item in LogPriorityList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('lang.smartlink.log')">
                <el-button type="danger" @click="downloadLog" size="mini">{{ $t('lang.smartlink.download')
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
    <el-button type="danger" size="mini" class="Config-Buttom" @click="updateConfig">
      {{ $t('lang.ConfigSetting.SaveApply') }}
    </el-button>
  </div>
</template>
<script>
import { updateConfig, listConfig, getLog } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import { cloneDeep, isEqual } from 'lodash'
export default {
  props: ["deviceDid", "deviceSn", "deviceSoftwareVer"],
  data() {
    return {
      loading: true,
      UpData: true,
      data: {},
      WatchData: {},
      advanced: {},
      WatchAdvanced: {},
      select: 'con',
      connectInfo: {
        'connected': '已连接',
        'disconnected': '未连接',
        'connecting': '连接中',
        'connect_failed': '连接失败',
        'unknown': '未知',
        'login_success': "登录成功",
        'login_faild': "登录失败",
        'logining': '登录中',
        'listening': 'Listening',
        'partial connected': 'Partial Connected'
      },
      LogPriorityList: [
        { value: '8', label: this.$t('lang.smartlink.debug') },
        { value: '7', label: this.$t('lang.smartlink.info') },
        { value: '6', label: this.$t('lang.smartlink.notice') },
        { value: '5', label: this.$t('lang.smartlink.alarm') },
        { value: '4', label: this.$t('lang.smartlink.error') },
        { value: '3', label: this.$t('lang.smartlink.deadly') },
        { value: '2', label: this.$t('lang.smartlink.alert') },
        { value: '1', label: this.$t('lang.smartlink.emergency') }
      ],
    }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig()
      },
    }
  },
  methods: {
    // 获取配置参数
    getConfig() {
      this.loading = true
      if (this.deviceSoftwareVer >= "v2.9") {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "setting",
            config: "smartm2m",
            options: [
              { option: "v2_enabled" },
              { option: "v2_ping_check" },
              { option: "v2_status" },
              // { option: "v2_conn3_server" },
              // { option: "v2_conn5_server" },
              // { option: "v3_upgrade_ready" },
              // { option: "v3_enabled" },
              // { option: "v3_mqtt_qos" },
              // { option: "v3_mqtt_alive" },
              { option: "v3_status" },
              { option: "version" },
            ],
            lists: [
              { list: "v2_server" },
              { list: "v3_server" },
            ]
          },
          {
            section: "service",
            config: "smartm2m",
            options: [
              { option: "enabled" },
              { option: "enable_debug" },
              { option: "log_file_num" },
              { option: "log_file_size" },
              { option: "log_priority" },
            ],
          },
          {
            section: "CONN5",
            config: "smartm2m",
            lists: [
              { list: "server" },
            ]
          },
          {
            section: "CONN3",
            config: "smartm2m",
            lists: [
              { list: "server" },
            ]
          },
          {
            section: "CONN1",
            config: "smartm2m",
            options: [
              { option: "mqtt_qos" },
              { option: "mqtt_alive" },
              { option: "enabled" },
              { option: "upgrade_ready" },
            ],
            lists: [
              { list: "server" },
            ]
          }
        ]).then(res => {
          let data = res.data.data.mess[0].s_objects[0].options

          let lists = res.data.data.mess[0].s_objects[0].lists
          let conn5 = res.data.data.mess[2].s_objects;
          let conn3 = res.data.data.mess[3].s_objects;
          let conn1 = res.data.data.mess[4].s_objects;
          this.data = {
            ...data,
            v2_enabled: data.v2_enabled == '1',
            v2_ping_check: data.v2_ping_check == '1',
            v3_upgrade_ready: data.v3_upgrade_ready == '1',
            v3_enabled: conn1[0].options.enabled == '1',
            v2_server: lists.v2_server.length === 0 ? [''] : lists.v2_server,
            v3_server: lists.v3_server.length === 0 ? [''] : lists.v3_server
          }
          // let v2_mqtt = res.data.data.mess[2].s_objects[0].lists
          // let v2_tcp = res.data.data.mess[3].s_objects[0].lists
          if (this.deviceSoftwareVer >= "v2.9.250301") {

            this.$set(this.data, 'v2_mqtt', conn5[0].lists.server.length === 0 ? [''] : conn5[0].lists.server)
            this.$set(this.data, 'v2_tcp', conn3[0].lists.server.length === 0 ? [''] : conn3[0].lists.server)
            this.data.v3_server = conn1[0].lists.server;
            // this.v3_mqtt_qos = conn1[0].options.mqtt_qos
            this.$set(this.data, 'v3_mqtt_qos', conn1[0].options.mqtt_qos)
            this.$set(this.data, 'v3_mqtt_alive', conn1[0].options.mqtt_alive)
            this.$set(this.data, 'v3_upgrade_ready', conn1[0].options.upgrade_ready)
            // this.v3_mqtt_alive = conn1[0].options.mqtt_alive
          }
          this.advanced = res.data.data.mess[1].s_objects[0].options
          this.advanced.enabled = this.advanced.enabled === '1' ? true : false
          this.advanced.enable_debug = this.advanced.enable_debug === '1' ? true : false

          this.WatchAdvanced = cloneDeep(this.advanced)
          this.WatchData = cloneDeep(this.data)
          this.loading = false
        }).catch(err => {
          console.log(err);

          this.$message({
            message: this.$t('lang.request.timeout'),
            type: "warning"
          });
        });
      } else {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "centerserver",
            config: "m2m",
            options: [
              { option: "m2m_enabled" },
              { option: "hbpt" },
              { option: "vtime" },
              { option: "nspt" },
              { option: "server_v2" },
              { option: "port_v2" },
              { option: "loc_inter" },
            ],
            lists: [
              { list: "server" }
            ]
          }
        ]).then(res => {
          this.data = res.data.data.mess[0].s_objects[0].options;
          this.data.m2m_enabled == 1 ? this.$set(this.data, 'm2m_enabled', true) : this.$set(this.data, 'm2m_enabled', false)
          this.WatchData = cloneDeep(this.data)
          this.loading = false
        }).catch(err => {
          this.$message({
            message: this.$t('lang.request.timeout'),
            type: "warning"
          });
        });
      }
    },
    //保存配置
    updateConfig() {
      if (this.deviceSoftwareVer >= "v2.9") {
        if (this.select === 'con') {
          if (!(isEqual(this.data, this.WatchData))) {
            this.loading = true
            updateConfig(this.deviceSn, this.deviceDid, [
              {
                section: "setting",
                config: "smartm2m",
                action: 0,
                index: [0],
                // sname: 'setting',
                options: {
                  ...this.data,
                  v2_enabled: this.data.v2_enabled ? "1" : "0",
                  v3_enabled: this.data.v3_enabled ? "1" : "0",
                  v2_ping_check: this.data.v2_ping_check ? "1" : "0",
                  v3_upgrade_ready: this.data.v3_upgrade_ready ? "1" : "0",
                  v2_server: undefined,
                  v3_server: undefined,
                  v2_status: undefined,
                  v3_status: undefined,
                  v2_mqtt:undefined,
                  v2_tcp:undefined
                },
                lists: {
                  v2_server: this.data.v2_server.filter(v => v !== ""),
                  v3_server: this.data.v3_server.length === 0 ? undefined : this.data.v3_server.filter(v => v !== "")
                }
              },
              {
                section: "CONN1",
                config: "smartm2m",
                action: 0,
                index: [0],
                // sname: 'CONN1',
                options: {
                  enabled: this.data.v3_enabled ? "1" : "0",
                  upgrade_ready: this.data.v3_upgrade_ready ? "1" : "0",
                  mqtt_qos: this.data.v3_mqtt_qos,
                  mqtt_alive: this.data.v3_mqtt_alive,
                },
                lists: {
                  server: this.data.v3_server.filter(v => v !== "")
                }
              },
              {
                section: "CONN3",
                config: "smartm2m",
                action: 0,
                index: [0],
                // sname: 'CONN3',
                options: {
                  enabled: this.data.v2_enabled ? "1" : "0",
                  ping_check: this.data.v2_ping_check ? "1" : "0",
                },
                lists: {
                  server: this.data.v2_tcp.filter(i => i != '')
                },
              },
              {
                section: "CONN5",
                config: "smartm2m",
                action: 0,
                index: [0],
                // sname: 'CONN5',
                options: {
                  enabled: this.data.v2_enabled ? "1" : "0",
                },
                lists: {
                  server: this.data.v2_mqtt.filter(i => i != '')
                },
              }
            ]).then(res => {
              if (res.data.data.mess === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                  type: "success"
                });
                progressControl([
                  {
                    process: 'smartm2m',
                    type: 0,
                    action: 'restart'
                  }
                ], this.deviceDid, this.deviceSn).then(res => {
                  this.getConfig()
                })
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('lang.ConfigSetting.Configurationerror'),
                  type: 'warning'
                });
              }
            }).finally(() => {
              this.loading = false;
            })
          } else {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Nochangesmade'),
              type: 'warning'
            });
          }
        } else {
          this.loading = true
          updateConfig(this.deviceSn, this.deviceDid, [
            {
              config: "smartm2m",
              section: "service",
              server: "smartm2m",
              action: 0,
              index: [0],
              options: {
                ...this.advanced,
                enabled: this.advanced.enabled ? 1 : 0,
                enable_debug: this.advanced.enable_debug ? 1 : 0
              },
            }
          ]).then(res => {
            if (res.data.data.mess === 0) {
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: "success"
              });
              this.getConfig()
            } else {
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Configurationerror'),
                type: 'warning'
              });
            }
          })
        }
      } else {
        if (!isEqual(this.data, this.WatchData)) {
          this.loading = true
          this.data.m2m_enabled ? this.data.m2m_enabled = 1 : this.data.m2m_enabled = ''
          updateConfig(this.deviceSn, this.deviceDid, [
            {
              section: "centerserver",
              config: "m2m",
              action: 0,
              index: [0],
              server: 'm2m',
              options: {
                ...this.data
              }
            }
          ]).then((res) => {
            //保存请求成功
            this.UpData = true
            if (res.data.data.mess === 0) {
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: "success"
              });
              this.getConfig()
            } else {
              this.$message({
                showClose: true,
                message: this.$t('lang.ConfigSetting.Configurationerror'),
                type: 'warning'
              });
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message({
            showClose: true,
            message: this.$t('lang.ConfigSetting.Nochangesmade'),
            type: 'warning'
          });
          return
        }
      }

    },
    delServer(index, t) {
      if (t === 'v2') {
        this.data.v2_server.splice(index, 1);
      } else if (t === 'v3') {
        this.data.v3_server.splice(index, 1);
      }
    },
    addServer(t) {
      if (t === 'v2') {
        this.data.v2_server.push("");
      } else if (t === 'v3') {
        this.data.v3_server.push("");
      }
    },
    downloadLog() {
      let params = {
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: "smartm2m"
      }
      getLog(params).then(res => {
        let blob = new Blob([res.data], { type: 'application/octet-stream' });
        let fileName = 'log.txt';
        if ('download' in document.createElement('a')) { // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  }
}
</script>
<style src='../common.css' scoped></style>
<style scoped>
.input_item {
  width: 240px;
  margin-right: 10px;
}

.input_box {
  display: flex;
  flex-direction: column;
}

.tips {
  color: #999;
  font-size: 12px;
}

.btn_box {
  float: right;
}

.input_list {
  display: flex;
  align-items: center;
}
</style>